import React from 'react';

import './FirmwareBox.scss';

interface Props extends React.HTMLAttributes<HTMLElement> {
  title?: string;
}

const FirmwareBox = (props: Props) => {
  const { children, title, ...rest } = props;
  return (
    <div className="firmware-box-component" {...rest}>
      <span className="box-title">{title}<hr /></span>
      {children}
    </div>
  );
};

export default FirmwareBox;
